import { PermissionT } from "../types";

export const proposalManagement = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "proposal_management");
  return !!p;
};

export default proposalManagement;
